/**
 * @description 登录、获取用户信息、退出登录、清除accessToken逻辑，不建议修改
 */

import { getUserInfo, login, logout } from '@/api/user'
import {
  getAccessToken,
  removeAccessToken,
  setAccessToken,
} from '@/utils/accessToken'
import { message } from 'ant-design-vue'

const state = () => ({
  accessToken: getAccessToken(),
  username: '',
  llid: '',
  email: '',
  title: '',
  brand: '',
  hrbp: '',
  lineManager: null,
  applicationPeriod: [],
  applicationApprovalPeriod: [],
  hrbpReviewDate: [],
  hrbpSubmitDate: [],
  avator: null,
  offlineMode: 0,
})
const getters = {
  accessToken: (state) => state.accessToken,
  username: (state) => state.username,
  llid: (state) => state.llid,
  email: (state) => state.email,
  brand: (state) => state.brand,
  hrbp: (state) => state.hrbp,
  lineManager: (state) => state.lineManager,
  title: (state) => state.title,
  applicationPeriod: (state) => state.applicationPeriod,
  applicationApprovalPeriod: (state) => state.applicationApprovalPeriod,
  hrbpReviewDate: (state) => state.hrbpReviewDate,
  hrbpSubmitDate: (state) => state.hrbpSubmitDate,
  avator: (state) => state.avator,
  offlineMode: (state) => state.offlineMode,
}
const mutations = {
  /**
   * @description 设置accessToken
   * @param {*} state
   * @param {*} accessToken
   */
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken
    setAccessToken(accessToken)
  },
  /**
   
   * @description 设置用户ID
   * @param {*} state
   * @param {*} llid
   */
  setLlID(state, llid) {
    state.llid = llid
  },
  /**
   
   * @description 设置用户名
   * @param {*} state
   * @param {*} username
   */
  setUsername(state, username) {
    state.username = username
  },
  /**
   
   * @description 设置邮箱
   * @param {*} state
   * @param {*} email
   */
  setEmail(state, email) {
    state.email = email
  },

  setLineManager(state, lineManager) {
    state.lineManager = lineManager
  },
  setBrand(state, brand) {
    state.brand = brand
  },
  setTitle(state, title) {
    state.title = title
  },
  setHrbp(state, hrbp) {
    state.hrbp = hrbp
  },
  setHRBPApplicatinDate(state, data) {
    state.hrbpReviewDate = data.hrbpReviewDate
    state.hrbpSubmitDate = data.hrbpSubmitDate
  },
  setApplicationPeriod(state, applicationPeriod) {
    state.applicationPeriod = applicationPeriod
  },
  setApplicationApprovalPeriod(state, applicationApprovalPeriod) {
    state.applicationApprovalPeriod = applicationApprovalPeriod
  },
  setAvator(state, avator) {
    state.avator = avator
  },
  setOfflineMode(state, offlineMode) {
    state.offlineMode = offlineMode
  },
}
const actions = {
  /**
   
   * @description 登录拦截放行时，设置虚拟角色
   * @param {*} { commit, dispatch }
   */
  setVirtualRoles({ commit, dispatch }) {
    dispatch('acl/setFull', true, { root: true })
    // commit('setAvatar', 'https://i.gtimg.cn/club/item/face/img/2/15922_100.gif')
    commit('setUsername', 'admin(未开启登录拦截)')
  },
  /**
   
   * @description 登录
   * @param {*} { commit }
   * @param {*} userInfo
   */
  async login({ commit, dispatch }, userInfo) {
    const { data } = await login(userInfo)
    const accessToken = data['token']
    if (accessToken) {
      commit('setAccessToken', accessToken)
      commit('setUsername', data.name)
      commit('setEmail', data.email)
      commit('setLlID', userInfo.llid)

      const roles = data.role
      dispatch('acl/setRole', roles, { root: true })
      dispatch('routes/setRoutes', null, { root: true })
      dispatch('getUserInfo')
    } else {
      message.error(`登录接口异常，未正确返回TOKEN...`)
    }
  },
  /**
   
   * @description 获取用户信息接口 这个接口非常非常重要，如果没有明确底层前逻辑禁止修改此方法，错误的修改可能造成整个框架无法正常使用
   * @param {*} { commit, dispatch, state }
   * @returns
   */
  async getUserInfo({ commit, dispatch, state }) {
    const { data } = await getUserInfo()
    if (!data) {
      message.error(`验证失败，请重新登录...`)
      return false
    }
    let { llid, name, email, brand, title } = data
    const roles = data.role

    if (llid) {
      commit('setUsername', name)
      commit('setEmail', email)
      commit('setLlID', llid)
      commit('setBrand', data.brand)
      commit('setTitle', data.title)
      commit('setLineManager', data.lm)
      commit('setHrbp', data.hrbp)
      // date
      if (data.apply_et) {
        commit('setApplicationPeriod', [data.apply_st, data.apply_et])
      }
      if (data.lm_et) {
        commit('setApplicationApprovalPeriod', [data.lm_st, data.lm_et])
      }
      if (data.hrbp_review_et && data.hrbp_submit_et) {
        commit('setHRBPApplicatinDate', {
          hrbpReviewDate: [data.hrbp_review_st, data.hrbp_review_et],
          hrbpSubmitDate: [data.hrbp_submit_st, data.hrbp_submit_et],
        })
      }
      // offline mode
      if (data.offline_mode !== undefined) {
        commit('setOfflineMode', data.offline_mode)
      }
      // ability
      const ability = [
        { key: 'can_reopen', value: data.can_reopen || false },
        { key: 'hrbp_working', value: !data.hrbp_ending || false },
        { key: 'can_upload', value: data.can_upload || false },
        // { key: 'can_operation', value: data.can_operation || false },
        { key: 'can_cancel_account', value: data.can_cancel_account || false },
        // { key: 'can_edit_window', value: data.can_edit_window || false },
        {
          key: 'can_upload_employee',
          value: data.can_upload_employee || false,
        },
        { key: 'can_upload_guide', value: data.can_upload_guide || false },
        {
          key: 'can_upload_learning_link',
          value: data.can_upload_learning_link || false,
        },
        {
          key: 'can_upload_learning_record',
          value: data.can_upload_learning_record || false,
        },
        { key: 'can_publish', value: data.can_publish || false },
        { key: 'in_scope', value: data.in_scope || false },
        { key: 'apply', value: data.can_apply || false },
        { key: 'check_history', value: data.can_check_history || false },
        { key: 'window_active', value: !!data.window_active },
        { key: 'hrbp_reviewing', value: !!data.hrbp_reviewing },
      ]
      dispatch('acl/setAbility', ability, { root: true })
      // roles
      dispatch('acl/setRole', roles, { root: true })
    } else {
      await dispatch('resetAll')
      message.error('用户信息接口异常')
    }
  },

  /**
   * @description 退出登录
   * @param {*} { dispatch }
   */
  async logout({ dispatch }) {
    await logout(state.accessToken)
    await dispatch('resetAll')
  },
  /**
   
   * @description 重置accessToken、roles、ability、router等
   * @param {*} { commit, dispatch }
   */
  async resetAll({ dispatch }) {
    await dispatch('setAccessToken', '')
    await dispatch('acl/setFull', false, { root: true })
    await dispatch('acl/setRole', [], { root: true })
    await dispatch('acl/setAbility', [], { root: true })
    removeAccessToken()
  },
  /**
   
   * @description 设置token
   */
  setAccessToken({ commit }, accessToken) {
    commit('setAccessToken', accessToken)
  },

  setAvator({ commit }, data) {
    commit('setAvator', data)
  },
}
export default { state, getters, mutations, actions }
